import { PageLayout } from "@ezmid/components-library";
import { useTranslation } from "react-i18next";

import { PaymentsDetailPageContent } from "../organisms/PaymentsDetailPageContent";

export function PaymentsDetailPage() {
  const { t } = useTranslation();
  return (
    <PageLayout title={t("app.page.payments.information")}>
      <PaymentsDetailPageContent />
    </PageLayout>
  );
}
